export default __webpack_public_path__ + "static/media/before_session.e3c9fe6b.png";